
export class UADetector {

    public static isIPhone()
    {
        const ua = navigator.userAgent
        return (ua.indexOf('iPhone') > 0)
    }

    public static isIPad()
    {
        const ua = navigator.userAgent
        return (ua.indexOf('iPad') > 0)

    }

    public static isMobile() {
        var ua = navigator.userAgent;
        if (/iPad|Macintosh/i.test(ua) && 'ontouchend' in document) {
            // iPadOS devices are presented as Macintosh on a desktop mode, so we need an additional touch feature check.
            return true;
        } else if (/iPhone/i.test(ua)) {
            return true;
        } else if (/android/i.test(ua)) {
            return true;
        } else {
            return false;
        }
    }

    /**
     * True for Android devices only.
     * Used to gate the custom image-source dialog: Android's native file input does not
     * reliably offer a camera/gallery choice (some devices jump straight to camera or
     * straight to the library), whereas iOS always shows its own native sheet
     * (Photo Library / Take Photo / Choose File). So the custom dialog is Android-only;
     * on iOS the native sheet already does the job and a custom dialog only double-prompts.
     */
    public static isAndroid() {
        return /android/i.test(navigator.userAgent);
    }
}
